import { render } from "./401.vue?vue&type=template&id=31b30b8a&scoped=true"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"

import "./401.vue?vue&type=style&index=0&id=31b30b8a&lang=less"
import "./401.vue?vue&type=style&index=1&id=31b30b8a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-31b30b8a"

export default script